import { useState } from "react";
import { toast } from "react-toastify";
import Input from "../../componentes/input/input";
import Button from "../../componentes/button/button";
import MeuUsuarioService from "../../services/resource/meuUsuarioService";

const service = new MeuUsuarioService();

const VALORES_INICIAIS = { senhaAtual: "", novaSenha: "", confirmarSenha: "" };

export default function AlterarSenhaCard() {
    const [valores, setValores] = useState(VALORES_INICIAIS);
    const [enviando, setEnviando] = useState(false);

    function setCampo(campo, valor) {
        setValores(prev => ({ ...prev, [campo]: valor }));
    }

    function validar() {
        if (!valores.senhaAtual || !valores.novaSenha || !valores.confirmarSenha) {
            toast.error("Preencha todos os campos");
            return false;
        }
        if (valores.novaSenha.length < 6) {
            toast.error("A nova senha deve ter ao menos 6 caracteres");
            return false;
        }
        if (valores.novaSenha !== valores.confirmarSenha) {
            toast.error("A confirmação não coincide com a nova senha");
            return false;
        }
        return true;
    }

    function salvar(e) {
        e.preventDefault();
        if (!validar()) return;

        setEnviando(true);
        service.alterarSenha({ senhaAtual: valores.senhaAtual, novaSenha: valores.novaSenha })
            .then(() => {
                toast.success("Senha alterada com sucesso!");
                setValores(VALORES_INICIAIS);
            })
            .catch(() => {})
            .finally(() => setEnviando(false));
    }

    return (
        <form onSubmit={salvar} className="flex flex-col gap-5 pt-2 max-w-md">
            <Input
                label="Senha Atual"
                type="password"
                required
                value={valores.senhaAtual}
                onChange={e => setCampo("senhaAtual", e.target.value)}
                disabled={enviando}
            />
            <Input
                label="Nova Senha"
                type="password"
                required
                helpText="Mínimo de 6 caracteres"
                value={valores.novaSenha}
                onChange={e => setCampo("novaSenha", e.target.value)}
                disabled={enviando}
            />
            <Input
                label="Confirmar Nova Senha"
                type="password"
                required
                value={valores.confirmarSenha}
                onChange={e => setCampo("confirmarSenha", e.target.value)}
                disabled={enviando}
            />

            <div className="flex justify-end">
                <Button
                    type="submit"
                    iconLeft="fa fa-check"
                    label="Alterar Senha"
                    loading={enviando}
                />
            </div>
        </form>
    );
}
